
export default function NaesinSection() {
  const steps = [
    {
      step: '1단계',
      title: '자료수집',
      description: '학교별 모든 수업 교과서 및 프린트 정리',
    },
    {
      step: '2단계',
      title: '교재준비',
      description: '자습서 외 학원 자체 제작 내신 교재',
    },
    {
      step: '3단계',
      title: '반복학습',
      description: '10회독을 목표로 전지문 분석 반복',
    },
    {
      step: '4단계',
      title: '유형접근',
      description: '지문별 기본 문항 및 기출 연계 문항 풀이',
    },
    {
      step: '5단계',
      title: '실전연습',
      description: '매주 실전 내신 모고 실시, 약점 파악',
    },
    {
      step: '6단계',
      title: '숙제관리',
      description: '지정 요일 줌으로 숙제 시간 확보 관리',
    },
    {
      step: '7단계',
      title: '통합관리',
      description: '학생&학부모&강사 학습방 운영, 복습영상제공',
    },
  ];

  const stepColors = [
    'text-[#ff6b6b]',
    'text-[#4ecdc4]',
    'text-[#ffd93d]',
    'text-[#ff6b6b]',
    'text-[#4ecdc4]',
    'text-[#ffd93d]',
    'text-[#ff6b6b]',
  ];

  const dotColors = [
    'bg-[#ff6b6b]',
    'bg-[#4ecdc4]',
    'bg-[#ffd93d]',
    'bg-[#ff6b6b]',
    'bg-[#4ecdc4]',
    'bg-[#ffd93d]',
    'bg-[#ff6b6b]',
  ];

  return (
    <section id="naesin" className="py-14 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-5 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-10 md:mb-14">
          <p className="text-[13px] md:text-base text-[#ff6b6b] font-medium mb-4 tracking-wider">
            Exam Prep Program
          </p>
          <h2
            className="text-[1.6rem] md:text-5xl font-bold text-[#1a2332] mb-4"
            style={{ fontFamily: 'Noto Serif KR, serif' }}
          >
            후니국담 <span className="text-[#4ecdc4]">내신 프로그램</span>
          </h2>
          <p className="text-gray-500 text-[14px] md:text-lg leading-relaxed">
            체계적인 7단계 내신 대비 프로그램으로 완벽한 시험 준비를 도와드립니다
          </p>
        </div>

        {/* Content Area */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 md:gap-10">
          {/* Left Side - Visual Card */}
          <div className="lg:col-span-4">
            <div className="bg-gradient-to-br from-[#1a2332] to-[#2a3f5f] rounded-2xl p-8 md:p-10 h-full flex flex-col items-center justify-center text-center min-h-[320px]">
              <p className="text-gray-300 text-base font-medium mb-3 tracking-wider">
                열린학원
              </p>
              <h3
                className="text-5xl md:text-6xl font-black text-[#ffd93d] leading-tight mb-4"
                style={{ fontFamily: 'Noto Serif KR, serif' }}
              >
                내신<br />대비
              </h3>
              <div className="w-16 h-1 bg-[#4ecdc4] rounded-full mb-4"></div>
              <p className="text-gray-400 text-sm">
                7단계 완벽 관리 시스템
              </p>
            </div>
          </div>

          {/* Right Side - Table */}
          <div className="lg:col-span-8">
            <div className="bg-white rounded-2xl shadow-md overflow-hidden">
              {/* Table Header */}
              <div className="bg-gradient-to-br from-[#1a2332] to-[#2a3f5f] px-8 py-6 text-center">
                <h3
                  className="text-2xl md:text-3xl font-bold text-[#ffd93d]"
                  style={{ fontFamily: 'Noto Serif KR, serif' }}
                >
                  국담 내신 프로그램
                </h3>
              </div>

              {/* Desktop Table */}
              <div className="hidden md:block">
                <table className="w-full border-collapse">
                  <thead>
                    <tr className="bg-[#f7f7f5]">
                      <th className="py-3.5 px-5 text-[#1a2332] text-sm font-bold text-center w-[90px] border-b border-gray-200">단계</th>
                      <th className="py-3.5 px-5 text-[#1a2332] text-sm font-bold text-center w-[120px] border-b border-gray-200">구분</th>
                      <th className="py-3.5 px-5 text-[#1a2332] text-sm font-bold text-left border-b border-gray-200">내용</th>
                    </tr>
                  </thead>
                  <tbody>
                    {steps.map((item, index) => {
                      const isLast = index === steps.length - 1;
                      return (
                        <tr
                          key={item.step}
                          className={`${!isLast ? 'border-b border-gray-100' : ''} hover:bg-gray-50/50 transition-colors duration-200`}
                        >
                          <td className="py-4.5 px-5 text-center border-r border-gray-100">
                            <span className={`text-sm font-bold ${stepColors[index]}`}>
                              {item.step}
                            </span>
                          </td>
                          <td className="py-4.5 px-5 text-center border-r border-gray-100">
                            <span className="text-[#1a2332] text-base font-semibold">
                              {item.title}
                            </span>
                          </td>
                          <td className="py-4.5 px-5">
                            <div className="flex items-center gap-2.5 text-gray-700 text-base leading-relaxed">
                              <span className={`w-2 h-2 rounded-full ${dotColors[index]} flex-shrink-0`}></span>
                              {item.description}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Mobile Cards */}
              <div className="md:hidden p-4 space-y-3">
                {steps.map((item, index) => (
                  <div key={item.step} className="bg-gray-50 rounded-xl p-4 border border-gray-100">
                    <div className="flex items-center gap-3 mb-2">
                      <span className={`text-[13px] font-bold ${stepColors[index]}`}>
                        {item.step}
                      </span>
                      <span className="text-[#1a2332] text-[15px] font-semibold">
                        {item.title}
                      </span>
                    </div>
                    <div className="flex items-start gap-2 text-gray-700 text-[14px] leading-[1.7] pl-1">
                      <span className={`mt-1.5 w-1.5 h-1.5 rounded-full ${dotColors[index]} flex-shrink-0`}></span>
                      {item.description}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
